// extracted by mini-css-extract-plugin
module.exports = {"EventsCalendar":"CalendarSection_EventsCalendar__2EIzQ","IframeWrapper":"CalendarSection_IframeWrapper__1wvKZ"};